<template>
  <div class="bg-white rounded-lg m-3">
    <div class="border-b-0.5 flex justify-between items-center p-3">
      <p class="text-sm font-semibold">{{ title }}</p>

      <!-- <div  class="flex flex-wrap justify-end w-full gap-3"> -->
      <button
        v-if="itemIndex == 2 && data.length === 0"
        @click="showAddBank = true"
        class="bg-primary flex text-white items-center text-sm px-2 py-1 rounded-md cursor-pointer"
      >
        <img
          class="object-contain p-1.5 w-7"
          src="@/assets/icons/plus-small.svg"
          v-if="data.length === 0"
        />add
      </button>

      <button
        v-if="itemIndex == 2 && data.length > 0"
        @click="showEditBank = true"
        class="gap-1 text-white bg-primary flex justify-center items-center rounded-md"
      >
        <img
          class="object-contain p-1.5 w-7"
          src="@/assets/icons/pencil.png"
        />Edit
      </button>
      <!-- </div> -->
    </div>
    <div class="grid lg:grid-cols-2 justify-start px-3 py-5 w-3/4 text-sm">
      <div v-if="itemIndex == 1">
        <div v-if="data.length === 0">
          <p class="p-1 text-left">No Data</p>
        </div>
        <div v-else class="grid grid-cols-2 gap-x-2 gap-y-4">
          <div v-for="(item, index) in data" :key="index">
            <div
              v-for="(info, index) in item.info"
              :key="index"
              class="flex gap-0.5 align-top"
            >
              <input type="checkbox" name="" checked id="" />
              <p class="text-gray-400">
                {{ decryptDataLocal(info.value, decryptionKey) }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div v-if="itemIndex == 2">
        <div v-if="data.length === 0">
          <p class="p-1 text-left">No Data</p>
        </div>

        <div
          class="flex whitespace-nowrap mb-2"
          v-for="(item, index) in data[0].info"
          :key="index"
        >
          <p class="w-36 text-black">{{ item.name }}:</p>

          <div
            class="w-7/12 bg-gray-100 whitespace-nowrap text-gray-500 p-1 pr-2 rounded overflow-x-auto"
          >
            <p>{{ decryptDataLocal(item.value, decryptionKey) }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- create -->
    <AddBank
      @close="handleClose"
      :showAddBank="showAddBank"
      @closeOnSuccess="handleCloseOnSuccess"
      :reload="reload"
      :title="title"
      :data="data"
      :refreshData="refreshData"
    >
    </AddBank>
    <EditBank
      @close="showEditBank = false"
      :data="data"
      :showEditBank="showEditBank"
      @closeOnSuccess="handleCloseOnSuccess"
      :reload="reload"
    >
    </EditBank>
  </div>
</template>

<script>
import AddBank from "@/components/employees/modals/addBankDetails.vue";
import EditBank from "@/components/employees/modals/editBankDetails.vue";
import decryptData from "@/utils/decrypt";
export default {
  components: { AddBank, EditBank },
  name: "InformationCard",
  props: ["title", "data", "itemIndex", "reloadBankDetails"],

  data() {
    return {
      decryptDataLocal: "",
      decryptionKey: "",
      showAddBank: false,
      showEditBank: false,
      info: [],
    };
  },
  created() {
    this.decryptDataLocal = decryptData;
    this.decryptionKey = this.$decryptionKey;
  },
  methods: {
    refreshData() {
      return this.data;
    },
    handleClose() {
      this.showAddBank = false;
    },
    reload() {
      this.showAddBank = false;
      this.showEditBank = false;
      this.reloadBankDetails();
    },
  },
};
</script>
